export { Tab } from './Tab';
export type { TabProps } from './Tab';
export * from './Tabs';
